<div mat-dialog-content #dialogContent style="padding: 16px;">
  <h4 *ngIf="headerHTML" mat-dialog-title style="font-family: 'Roboto' !important;" [innerHTML]="headerHTML"></h4>

  <p #innerHtmlContent style="font-family: 'Roboto' !important;" *ngIf="ConfirmationHTML"><span
      [innerHTML]="ConfirmationHTML"></span></p>

  <mat-dialog-actions class="dialog-actions" align="end">
    <button *ngIf="data.woCancelButton!=true" mat-stroked-button class="btn btn-secondary"
      (click)="OnCancel()">Cancel</button>
    <button mat-stroked-button class="btn btn-primary" (click)="OnOK()" cdkFocusInitial>
      {{data.button ? data.button :'OK'}}
    </button>
  </mat-dialog-actions>
</div>